import React from "react";
import { Box, Stack } from "@mui/material";
import styled from "styled-components";
import spaceship from "../../assets/icons/spaceship";
import Icon from "../../components/icon";

const ErrorNumber = styled.p`
    font-size: 144px;
    font-weight: 700;
    margin: 0;
    padding: 0;
`;

const ErrorText = styled.p`
    font-size: 36px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.primary.main};
    margin: 0;
    padding: 0;
    text-transform: uppercase;
`;

const ErrorDescription = styled.p`
    font-size: 14px;
    font-weight: 300;
    margin: 0;
    padding: 0;
`;

const NotFound = () => {
    return (
        <Box my={3} mx={4} pb={3}>
            <Stack alignItems="center" spacing={2}>
                <Icon svg={spaceship} height="45px" width="83px" />
                <ErrorNumber>404</ErrorNumber>
                <ErrorText>Page not found</ErrorText>
                <ErrorDescription>
                    The page you are looking for might not be the page you are looking for...
                </ErrorDescription>
            </Stack>
        </Box>
    );
};

export default NotFound;
